import { data, user } from 'services';
import { StatusSetForm } from 'libs/forms';
import { prepareFilter } from 'libs/common';
import { getMeanType, getDateTime } from 'services/types';

export const getTableParams = (t) => {
  const setRight = user.haveRight('violations.bulk_change_state');
  const setActions = setRight
    ? [
        {
          title: 'Статус',
          key: 'is_active',
          form: StatusSetForm,
          dict: 'violations.status',
          // dictExclude: ['blocked_by_client'],
          simple: false,
          method: 'violations.bulk_change_state',
          idsParam: 'ids',
          prepare: (data) => {
            return prepareFilter(data, {}, { boolFields: ['is_active'] });
          },
          //   const key = 'status';
          //   if (data[key] === 'active') {
          //     data['is_active'] = true;
          //   } else if (data[key] === 'archive') {
          //     data['is_active'] = false;
          //   }
          //   delete data[key];
          //   // return data;
          // },
        },
      ]
    : [];

  const getFields = () => {
    const fields = [
      {
        name: 'vehicle_plate',
        // sortField: 'vehicle_plate',
        title: t('sections.ГРЗ'),
        width: 120,
      },
      { name: 'violation_time', sortField: 'violation_time', title: t('grid.Дата и время'), width: 220, render: (val) => getDateTime(val) },
      {
        name: 'is_active',
        title: t('grid.Статус'),
        width: 120,
        render: (val) => data.getDictValue('violations.status', val),
      },
      {
        name: 'reason',
        title: t('form.Причина внесения'),
        // width: 150,
      },
      {
        name: 'mean_type',
        title: t('dict_filter.Тип'),
        width: 150,
        render: (val) => getMeanType(val),
      },
      {
        name: 'mean_id',
        title: t('buttons.Номер'),
        width: 170,
      },
    ];

    return fields;
  };

  return { getFields, setActions };
};
